import { adminImpersonationAPI } from './admin-impersonation.api'
import type {
  GetAdministratorsForImpersonationResponse,
  ImpersonateAdminResponse
} from './admin-impersonation.types'

/**
 * Admin impersonation service composable — pure async business logic.
 *
 * NO reactive state (loading, error refs) — the store handles that.
 * This layer wraps the API for admin impersonation operations.
 *
 * Architecture: View → Store → admin-impersonation.composable.ts → admin-impersonation.api.ts
 */
export function useAdminImpersonationService() {
  /**
   * Get all administrators available for impersonation.
   */
  const getAdministrators = async (): Promise<GetAdministratorsForImpersonationResponse> => {
    return adminImpersonationAPI.getAdministrators()
  }

  /**
   * Impersonate an administrator and get an access token.
   */
  const impersonateAdmin = async (
    administratorId: number,
    durationMinutes: number
  ): Promise<ImpersonateAdminResponse> => {
    return adminImpersonationAPI.impersonateAdmin(administratorId, durationMinutes)
  }

  /**
   * End the current impersonation session.
   */
  const endImpersonation = async (): Promise<void> => {
    return adminImpersonationAPI.endImpersonation()
  }

  return {
    getAdministrators,
    impersonateAdmin,
    endImpersonation
  }
}
